import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import cx from 'classnames';
import queryString from 'query-string';
import { Col, Row } from 'antd';

import BaseAlert from 'components/wrappers/BaseAlert/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import {
  createInvitedUserAccount,
  login,
} from 'redux/reducers/authenticationSlice';
import { ApplicationTypeEnum } from 'api/accountApiClient';
import style from '../AuthorizationPage.module.less';
import FormRegistration from 'components/FormRegistration';
import { RegistrationFormValues } from 'components/FormRegistration/FormRegistration';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { RegInvitedUserModel } from 'api/backofficeApiClient';

export default function RegistrationByInvitePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const query = queryString.parse(location.search);
  const dispatch = useAppDispatch();

  const initialValues: RegistrationFormValues = {
    businessName: '',
    firstName: '',
    lastName: '',
    email: query.email,
    password: '',
  };

  const handleSubmit = async (values: RegistrationFormValues) => {
    const { email, password, firstName, lastName } = values;
    const data: RegInvitedUserModel = {
      email,
      password,
      firstName,
      lastName,
      secretKey: query.c,
    };
    const result = await dispatch(createInvitedUserAccount(data));

    if (createInvitedUserAccount.fulfilled.match(result)) {
      const result = await dispatch(
        login({
          ...values,
          applicationType: ApplicationTypeEnum.Backoffice,
        }),
      );
      if (login.fulfilled.match(result)) {
        const pathname = '/';
        const { from } = (location.state as any) || {
          from: { pathname },
        };

        navigate(from, { replace: true });
      } else {
        BaseAlert.error(result.error.message || ApiErrorMessage);
      }
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  return (
    <div className={cx('scroll-box', style.authPage)}>
      <Row justify="end" className={style.fullHeight}>
        <Col xl={14}>
          <div className={style.authPageBg} />
        </Col>
        <Col xs={24} xl={10}>
          <FormRegistration
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            isEmailDisabled={true}
            isBusinessNameRequired={false}
          />
        </Col>
      </Row>
    </div>
  );
}
